export default function basketController($scope, Basket, Scroll, siteService) {
    $scope.bookings = Basket.currentBookings;

    const checkBookings = function () {
        angular.forEach($scope.bookings, function (booking) {
            let model = {
                start: booking.BookingStart,
                end: booking.BookingEnd,
                resourceId: 0, // ???
            };
        });
    };

    console.log("HUH");
    Scroll.to("title-focus", siteService.headerHeight + 15);

    // checkBookings();
}
